export default {
  //船舶一覧
  vessels: [],
  vesselId: null,
  vesselTotalPage: null,
  vesselTotalElements: null,

  //航海一覧
  voyages: [],
  voyageId: null,
  voyageTotalPage: null,
  voyageTotalElements: null,

  //省エネ解析詳細
  startPort: {},
  goalPort: {},

  //航路情報
  usualRoute: {},
  usualRouteWaypoints: [],
  recomendedRoute: {},
  recomendedRouteWaypoints: [],
  actualRoute: {},
  actualRouteWaypoints: [],
  actualRouteExistsRecommendedAggregatedData: {},
  routeAgreementRate: null,
  operationRate: null,
  routeFeatureCollection: null,

  //マップ
  showMap: false,
  mapCenterPosition: null,
  actualRouteLinesFeatures: null,
  sectionLinesFeatures: null,
  currentGraphSyncLine: null,
  mapInitialPosition: null,
  weatherRoutingResultsData: null,

  //グラフ
  chartSeries: [],
  chartData: [],
  enabledSwitchModels: [],

  //バルコムセンサー
  sensorColumn: [],
  sensorRowsData: [],
};
